import React from 'react';
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";
import _ from 'lodash';
import {fetchLikes} from "../../../creators/likes";

import Icon from "../Icon";
import {Link} from "react-router-dom";
import createLink from "../../../libs/createLink";
import Avatar from "../Avatar";
import {PageLoader, SpinLoader} from "../Loader";
import {Button} from "../Button";
import {isNoFollowProfil} from "../../../libs/helper";

class LikeList extends React.Component {
    constructor(props){
        super(props);
        this.filter = {
            page: 1,
            limit: 20,
            sort: "-createdAt"
        };
        this.state = {
            filter: this.filter,
            toggleLike: this.props.isLiked || false,
            classActive: false,
            value: this.props.value || 0,
            toggleSignIn: false
        };
        this.fetchLikeList = this.fetchLikeList.bind(this);
        this.nextLikeList = this.nextLikeList.bind(this);

        this.fetchLikeList(this.state.filter);
    };

    fetchLikeList(filter, more) {
        filter = {...filter};
        this.props.fetchLikes(this.props.likeType, this.props.parentId, filter, more);
    }

    nextLikeList() {
        let page = this.state.filter.page + 1;
        let newFilter = {...this.state.filter, page};
        this.fetchLikeList(newFilter,true);
        this.setState({filter: newFilter});
    }


    render(){
        return !this.props.likeInitialized ? (
            <div id="like-popup" className={"modal-container"}>
                <PageLoader />
            </div>
        ) : (
            <div id="like-popup" className={"modal-container"}>
                <div className="modal-topline">
                    {this.props.totalLikes} personne{this.props.totalLikes > 1 ? 's' : ''} {this.props.totalLikes > 1 ? 'ont' : 'a'} aimé
                    <span onClick={() => this.props.handleClose()}><Icon type="close"/></span>
                </div>
                <div className="like-list">
                    {this.props.totalLikes >= 1 ? (
                        <ul className="like-list-container">
                            {this.props.like.map(like => {
                                let relLinkProfil = isNoFollowProfil(like.owner) ? { rel: "nofollow" } : {};
                                if (_.get(like,'owner._id')) {
                                    return (
                                        <Link to={createLink("userProfile", like.owner)} key={like.owner._id} {...relLinkProfil}>
                                            <li>
                                                <Avatar avatar={like.owner.profile.avatar}
                                                        gender={like.owner.profile.gender}
                                                        className="user-thumb"
                                                        alt=""/> {like.owner.username}
                                            </li>
                                        </Link>)
                                } else return null;
                            })}
                            {this.props.likeMore && !this.props.likeLoading &&
                            <Button size={"small"}
                                    btnStyle={"primary-reverse"}
                                    onClick={()=>this.nextLikeList()}
                                    content={"Voir plus de J'aimes"}/>
                            }
                            {this.props.likeMore && this.props.likeLoading &&
                            <SpinLoader className={"small"}/>
                            }
                        </ul>

                    ) : (
                        <div className={"no-content"}>Aucun like</div>
                    )}

                </div>

            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        like: state.likes.data,
        likeLoading: state.likes.loading,
        likeInitialized: state.likes.initialized,
        totalLikes: state.likes.total,
        likeMore: state.likes.more
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchLikes,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LikeList);